export default __webpack_public_path__ + "static/MobileApplication-c5af3cc9d7cc85789d4589d0fb42b43f.mp4";